export const emptyFrame = [
  "eeeeeeeeeeeeeeeeeeeeee",
  "eeeeeeeeeeeeeeeeeeeeee",
  "eeeeeeeeeeeeeeeeeeeeee",
  "eeeeeeeeeeeeeeeeeeeeee",
  "eeeeeeeeeeeeeeeeeeeeee",
  "eeeeeeeeeeeeeeeeeeeeee",
  "eeeeeeeeeeeeeeeeeeeeee",
  "eeeeeeeeeeeeeeeeeeeeee",
  "eeeeeeeeeeeeeeeeeeeeee",
  "eeeeeeeeeeeeeeeeeeeeee",
  "eeeeeeeeeeeeeeeeeeeeee",
  "eeeeeeeeeeeeeeeeeeeeee",
];
export const honeyFrame = [
  "hhhhhhhhhhhhhhhhhhhhhh",
  "hhhhhhhhhhhhhhhhhhhhhh",
  "hhhhhhhhhhhhhhhhhhhhhh",
  "hhhhhhhhhhhhhhhhhhhhhh",
  "hhhhhhhhhhhhhhhhhhhhhh",
  "hhhhhhhhhhhhhhhhhhhhhh",
  "hhhhhhhhhhhhhhhhhhhhhh",
  "hhhhhhhhhhhhhhhhhhhhhh",
  "hhhhhhhhhhhhhhhhhhhhhh",
  "hhhhhhhhhhhhhhhhhhhhhh",
  "hhhhhhhhhhhhhhhhhhhhhh",
  "hhhhhhhhhhhhhhhhhhhhhh",
];
export const partialHoney = [
  [
    "eeeeeeeeeeeeeeeeeeeeee",
    "eeeeeeeeeeeeeeeeeeeeee",
    "eeeeeeeeeeeeeeeeeeeeee",
    "eeeeeeeeeeeeeeeeeeeeee",
    "eeeeeeeeeeeeeeeeeeeeee",
    "eeeeeeeeehhhheeeeeeeee",
    "eeeeeeeeeeeeeeeeeeeeee",
    "eeeeeeeeeeeeeeeeeeeeee",
    "eeeeeeeeeeeeeeeeeeeeee",
    "eeeeeeeeeeeeeeeeeeeeee",
    "eeeeeeeeeeeeeeeeeeeeee",
    "eeeeeeeeeeeeeeeeeeeeee",
  ],
  [
    "eeeeeeeeeeeeeeeeeeeeee",
    "eeeeeeeeeeeeeeeeeeeeee",
    "eeeeeeeeeeeeeeeeeeeeee",
    "eeeeeeeeeeeeeeeeeeeeee",
    "eeeeeeeeeeeeeeeeeeeeee",
    "eeeeeeehhhhhheeeeeeeee",
    "eeeeeeeehhhhheeeeeeeee",
    "eeeeeeeeeeeeeeeeeeeeee",
    "eeeeeeeeeeeeeeeeeeeeee",
    "eeeeeeeeeeeeeeeeeeeeee",
    "eeeeeeeeeeeeeeeeeeeeee",
    "eeeeeeeeeeeeeeeeeeeeee",
  ],
  [
    "eeeeeeeeeeeeeeeeeeeeee",
    "eeeeeeeeeeeeeeeeeeeeee",
    "eeeeeeeeeeeeeeeeeeeeee",
    "eeeeeeeeeeeeeeeeeeeeee",
    "eeeeeehhhhhhhhheeeeeee",
    "eeeehhhhhhhhhhhheeeeee",
    "eehhhhhhhhhhhhhhhheeee",
    "eeeeeeeeeeeeeeeeeeeeee",
    "eeeeeeeeeeeeeeeeeeeeee",
    "eeeeeeeeeeeeeeeeeeeeee",
    "eeeeeeeeeeeeeeeeeeeeee",
    "eeeeeeeeeeeeeeeeeeeeee",
  ],
  [
    "eeeeeeeeeeeeeeeeeeeeee",
    "eeeeeeeeeeeeeeeeeeeeee",
    "eeeeeeeeeeeeeeeeeeeeee",
    "eeeeeehhhhhhhheeeeeeee",
    "eeeehhhhhhhhhhheeeeeee",
    "eehhhhhhhhhhhhhhhheeee",
    "eehhhhhhhhhhhhhhhhhhee",
    "eeeeehhhhhhhhhhhheeeee",
    "eeeeeehhhhhhhhhheeeeee",
    "eeeeeeeeeeeeeeeeeeeeee",
    "eeeeeeeeeeeeeeeeeeeeee",
    "eeeeeeeeeeeeeeeeeeeeee",
  ],
  [
    "eeeeeeeeeeeeeeeeeeeeee",
    "eeeeeeeeeeeeeeeeeeeeee",
    "eeeeeeeeeeeeeeeeeeeeee",
    "eeeeeehhhhhhhheeeeeeee",
    "eeeehhhhhhhhhhheeeeeee",
    "eehhhhhhhhhhhhhhhheeee",
    "eehhhhhhhhhhhhhhhhhhee",
    "eeehhhhhhhhhhhhhhhheee",
    "eeeehhhhhhhhhhhhhheeee",
    "eeeeeeeeehhheeeeeeeeee",
    "eeeeeeeeeeeeeeeeeeeeee",
    "eeeeeeeeeeeeeeeeeeeeee",
  ],
  [
    "eeeeeeeeeeeeeeeeeeeeee",
    "eeeeeeeeeeeeeeeeeeeeee",
    "eeeeeeehhhhhheeeeeeeee",
    "eeeeeehhhhhhhhhheeeeee",
    "eeeehhhhhhhhhhheeeeeee",
    "eehhhhhhhhhhhhhhhheeee",
    "eehhhhhhhhhhhhhhhhhhee",
    "eehhhhhhhhhhhhhhhhhhee",
    "eehhhhhhhhhhhhhhhhhhee",
    "eeehhhhhhhhhhhhhhhheee",
    "eeeeeehhhhhhhhheeeeeee",
    "eeeeeeeeeeeeeeeeeeeeee",
  ],
  [
    "eeeeeeeeeeeeeeeeeeeeee",
    "eeeeeeeeeeeeeeeeeeeeee",
    "eeeeeeehhhhhheeeeeeeee",
    "eeehhhhhhhhhhhhhhheeee",
    "eehhhhhhhhhhhhhhhhheee",
    "eehhhhhhhhhhhhhhhheeee",
    "eehhhhhhhhhhhhhhhhhhee",
    "eehhhhhhhhhhhhhhhhhhee",
    "eehhhhhhhhhhhhhhhhhhee",
    "eeehhhhhhhhhhhhhhhheee",
    "eeeeeehhhhhhhhheeeeeee",
    "eeeeeeeeeeeeeeeeeeeeee",
  ],
  [
    "eeeeeeeeeeeeeeeeeeeeee",
    "eeeeeeehhhhhhhhheeeeee",
    "eeehhhhhhhhhhhhhhhheee",
    "eehhhhhhhhhhhhhhhhhhee",
    "ehhhhhhhhhhhhhhhhhhhee",
    "eehhhhhhhhhhhhhhhhhhee",
    "eehhhhhhhhhhhhhhhhhhee",
    "eehhhhhhhhhhhhhhhhhhee",
    "eehhhhhhhhhhhhhhhhhhee",
    "eeehhhhhhhhhhhhhhhheee",
    "eeeeeehhhhhhhhheeeeeee",
    "eeeeeeeeeeeeeeeeeeeeee",
  ],
  [
    "eeeeeeeeeeeeeeeeeeeeee",
    "eeeeeeehhhhhhhhheeeeee",
    "eeehhhhhhhhhhhhhhhheee",
    "eehhhhhhhhhhhhhhhhhhee",
    "ehhhhhhhhhhhhhhhhhhhhe",
    "eehhhhhhhhhhhhhhhhhhhe",
    "eehhhhhhhhhhhhhhhhhhee",
    "eehhhhhhhhhhhhhhhhhhee",
    "eehhhhhhhhhhhhhhhhhhee",
    "eeehhhhhhhhhhhhhhhheee",
    "eehhhhhhhhhhhhhhhhhhee",
    "eeeehhhhhhhhhhhheeeeee",
  ],
  [
    "eehhhhhhhhhhhhhhhhheee",
    "ehhhhhhhhhhhhhhhhhhhhe",
    "ehhhhhhhhhhhhhhhhhhhhe",
    "ehhhhhhhhhhhhhhhhhhhhe",
    "hhhhhhhhhhhhhhhhhhhhhh",
    "hhhhhhhhhhhhhhhhhhhhhh",
    "hhhhhhhhhhhhhhhhhhhhhh",
    "hhhhhhhhhhhhhhhhhhhhee",
    "eehhhhhhhhhhhhhhhhhhee",
    "ehhhhhhhhhhhhhhhhhhhhe",
    "eehhhhhhhhhhhhhhhhhhee",
    "eeeehhhhhhhhhhhheeeeee",
  ],
];
export const partialBrood = [
  [
    "eeeeeeeeeeeeeeeeeeeeee",
    "eeeeeeeeeeeeeeeeeeeeee",
    "eeeeeeeeeeeeeeeeeeeeee",
    "eeeeeeeeeeeeeeeeeeeeee",
    "eeeeeeeeeeeeeeeeeeeeee",
    "eeeeeeeee1111eeeeeeeee",
    "eeeeeeeeeeeeeeeeeeeeee",
    "eeeeeeeeeeeeeeeeeeeeee",
    "eeeeeeeeeeeeeeeeeeeeee",
    "eeeeeeeeeeeeeeeeeeeeee",
    "eeeeeeeeeeeeeeeeeeeeee",
    "eeeeeeeeeeeeeeeeeeeeee",
  ],
  [
    "eeeeeeeeeeeeeeeeeeeeee",
    "eeeeeeeeeeeeeeeeeeeeee",
    "eeeeeeeeeeeeeeeeeeeeee",
    "eeeeeeeeeeeeeeeeeeeeee",
    "eeeeeeeeeeeeeeeeeeeeee",
    "eeeeeee111111eeeeeeeee",
    "eeeeeeee11111eeeeeeeee",
    "eeeeeeeeeeeeeeeeeeeeee",
    "eeeeeeeeeeeeeeeeeeeeee",
    "eeeeeeeeeeeeeeeeeeeeee",
    "eeeeeeeeeeeeeeeeeeeeee",
    "eeeeeeeeeeeeeeeeeeeeee",
  ],
  [
    "eeeeeeeeeeeeeeeeeeeeee",
    "eeeeeeeeeeeeeeeeeeeeee",
    "eeeeeeeeeeeeeeeeeeeeee",
    "eeeeeeeeeeeeeeeeeeeeee",
    "eeeeee111111111eeeeeee",
    "eeee111111111111eeeeee",
    "ee1111111111111111eeee",
    "eeeeeeeeeeeeeeeeeeeeee",
    "eeeeeeeeeeeeeeeeeeeeee",
    "eeeeeeeeeeeeeeeeeeeeee",
    "eeeeeeeeeeeeeeeeeeeeee",
    "eeeeeeeeeeeeeeeeeeeeee",
  ],
  [
    "eeeeeeeeeeeeeeeeeeeeee",
    "eeeeeeeeeeeeeeeeeeeeee",
    "eeeeeeeeeeeeeeeeeeeeee",
    "eeeeeeeeeeeeeeeeeeeeee",
    "eeeeee111111111eeeeeee",
    "eeee111111111111eeeeee",
    "ee1111111111111111eeee",
    "eeee111111111111eeeeee",
    "eeeee1111111111eeeeeee",
    "eeeeeeeeeeeeeeeeeeeeee",
    "eeeeeeeeeeeeeeeeeeeeee",
    "eeeeeeeeeeeeeeeeeeeeee",
  ],
  [
    "eeeeeeeeeeeeeeeeeeeeee",
    "eeeeeeeeeeeeeeeeeeeeee",
    "eeeeeeeeeeeeeeeeeeeeee",
    "eeeeee11111111eeeeeeee",
    "eeee11111111111eeeeeee",
    "ee1111111111111111eeee",
    "ee111111111111111111ee",
    "eeeee111111111111eeeee",
    "eeeeee1111111111eeeeee",
    "eeeeeeeeeeeeeeeeeeeeee",
    "eeeeeeeeeeeeeeeeeeeeee",
    "eeeeeeeeeeeeeeeeeeeeee",
  ],
  [
    "eeeeeeeeeeeeeeeeeeeeee",
    "eeeeeeeeeeeeeeeeeeeeee",
    "eeeeeee111111eeeeeeeee",
    "eeeeee1111111111eeeeee",
    "eeee11111111111eeeeeee",
    "ee1111111111111111eeee",
    "ee111111111111111111ee",
    "ee111111111111111111ee",
    "ee111111111111111111ee",
    "eee1111111111111111eee",
    "eeeeee111111111eeeeeee",
    "eeeeeeeeeeeeeeeeeeeeee",
  ],
  [
    "eeeeeeeeeeeeeeeeeeeeee",
    "eeeeeeeeeeeeeeeeeeeeee",
    "eeeeeee111111eeeeeeeee",
    "eee111111111111111eeee",
    "ee11111111111111111eee",
    "ee1111111111111111eeee",
    "ee111111111111111111ee",
    "ee111111111111111111ee",
    "ee111111111111111111ee",
    "eee1111111111111111eee",
    "eeeeee111111111eeeeeee",
    "eeeeeeeeeeeeeeeeeeeeee",
  ],
  [
    "eeeeeeeeeeeeeeeeeeeeee",
    "eeeeeee111111111eeeeee",
    "eee1111111111111111eee",
    "ee111111111111111111ee",
    "e1111111111111111111ee",
    "ee111111111111111111ee",
    "ee111111111111111111ee",
    "ee111111111111111111ee",
    "ee111111111111111111ee",
    "eee1111111111111111eee",
    "eeeeee111111111eeeeeee",
    "eeeeeeeeeeeeeeeeeeeeee",
  ],
  [
    "eeeeeeeeeeeeeeeeeeeeee",
    "eeeeeee111111111eeeeee",
    "eee1111111111111111eee",
    "ee111111111111111111ee",
    "e11111111111111111111e",
    "ee1111111111111111111e",
    "ee111111111111111111ee",
    "ee111111111111111111ee",
    "ee111111111111111111ee",
    "eee1111111111111111eee",
    "ee111111111111111111ee",
    "eeee111111111111eeeeee",
  ],
  [
    "ee11111111111111111eee",
    "e11111111111111111111e",
    "e11111111111111111111e",
    "e11111111111111111111e",
    "1111111111111111111111",
    "1111111111111111111111",
    "1111111111111111111111",
    "11111111111111111111ee",
    "ee111111111111111111ee",
    "e11111111111111111111e",
    "ee111111111111111111ee",
    "eeee111111111111eeeeee",
  ],
];
export const broodFrames = [
  [
    "1111111111111111111111",
    "1111111111111111111111",
    "1111111111111111111111",
    "1111111111111111111111",
    "1111111111111111111111",
    "1111111111111111111111",
    "1111111111111111111111",
    "1111111111111111111111",
    "1111111111111111111111",
    "1111111111111111111111",
    "1111111111111111111111",
    "1111111111111111111111",
  ],
  [
    "1111111111111111111111",
    "1111111111111111111111",
    "1111111111111111111111",
    "1111111111111111111111",
    "1111111112222221111111",
    "1111111122222221111111",
    "1111111122222221111111",
    "1111111122222221111111",
    "1111111111111111111111",
    "1111111111111111111111",
    "1111111111111111111111",
    "1111111111111111111111",
  ],
  [
    "2222222222222222222222",
    "2222222222222222222222",
    "2222222222222222222222",
    "2222222222222222222222",
    "2222222222222222222222",
    "2222222233333322222222",
    "2222222233333322222222",
    "2222222333333322222222",
    "2222222233333332222222",
    "2222222222222222222222",
    "2222222222222222222222",
    "2222222222222222222222",
  ],
  [
    "3333333333333333333333",
    "3333333333333333333333",
    "3333333333333333333333",
    "3333333333333333333333",
    "3333333333333333333333",
    "3333333333333333333333",
    "3333333333333333333333",
    "3333333333333333333333",
    "3333333333333333333333",
    "3333333333333333333333",
    "3333333333333333333333",
    "3333333333333333333333",
  ],
  [
    "4444444444444444444444",
    "4444444444444444444444",
    "4444444444444444444444",
    "4444444444444444444444",
    "4444444444444444444444",
    "4444444444444444444444",
    "4444444444444444444444",
    "4444444444444444444444",
    "4444444444444444444444",
    "4444444444444444444444",
    "4444444444444444444444",
    "4444444444444444444444",
  ],
  [
    "4444455555555555444444",
    "4444455555555555444444",
    "4444455555555555444444",
    "4444555555555555544444",
    "4444555555555555544444",
    "4444555555555555544444",
    "4444555555555555544444",
    "4444455555555555444444",
    "4444455555555555444444",
    "4444455555555555444444",
    "4444455555555555444444",
    "4444455555555555444444",
  ],
  [
    "5555555555555555555555",
    "5555555555555555555555",
    "5555555555555555555555",
    "5555555555555555555555",
    "5555555555555555555555",
    "5555555555555555555555",
    "5555555555555555555555",
    "5555555555555555555555",
    "5555555555555555555555",
    "5555555555555555555555",
    "5555555555555555555555",
    "5555555555555555555555",
  ],
  [
    "6666666666666666666666",
    "6666666666666666666666",
    "6666666666666666666666",
    "6666666666666666666666",
    "6666666666666666666666",
    "6666666666666666666666",
    "6666666666666666666666",
    "6666666666666666666666",
    "6666666666666666666666",
    "6666666666666666666666",
    "6666666666666666666666",
    "6666666666666666666666",
  ],
  [
    "6666666666666666666666",
    "6666666666666666666666",
    "6666666666666666666666",
    "6666667777777777766666",
    "6666667777777777766666",
    "6666677777777777766666",
    "6666666777777766666666",
    "6666666677777777776666",
    "6666667777777777776666",
    "6666666666666666666666",
    "6666666666666666666666",
    "6666666666666666666666",
  ],
  [
    "7777777777777777777777",
    "7777777777777777777777",
    "7777777777777777777777",
    "7777777777777777777777",
    "7777777777777777777777",
    "7777777777777777777777",
    "7777777777777777777777",
    "7777777777777777777777",
    "7777777777777777777777",
    "7777777777777777777777",
    "7777777777777777777777",
    "7777777777777777777777",
  ],
];

export const honeyFrames = [
  [
    "hhhhhhhhhhhhhhhhhhhhhhhh",
    "hhhhhhhhhhhhhhhhhhhhhhhh",
    "hhhhhhhhhhhhhhhhhhhhhhhh",
    "hhhhhhhhhhhhhhhhhhhhhhhh",
    "hhhhhhhhhhhhhhhhhhhhhhhh",
    "hhhhhhhhhhhhhhhhhhhhhhhh",
    "hhhhhhhhhhhhhhhhhhhhhhhh",
    "hhhhhhhhhhhhhhhhhhhhhhhh",
    "hhhhhhhhhhhhhhhhhhhhhhhh",
    "hhhhhhhhhhhhhhhhhhhhhhhh",
    "hhhhhhhhhhhhhhhhhhhhhhhh",
    "hhhhhhhhhhhhhhhhhhhhhhhh",
  ],
];
